var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"flex align-center gap5 width-content",style:({flexDirection: _vm.reverse? 'row-reverse' : 'row'}),attrs:{"to":{ name: 'AccountDetails', params: { id: _vm.account._id } }}},[_c('Avatar',{attrs:{"account":_vm.account}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.username))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }